
/*
 * ZAP! CREATIVES — EDITORIAL BLOG
 *
 * Content is managed through Shopify Blog Posts.
 *
 * Heading 2 = New editorial section
 * Images = Positioned beside section text
 * Blockquote = Full-width testimonial
 *
 * Original article content remains readable without JS.
 */

(function () {
  function buildArticle(article) {
    const body = article.querySelector('[data-zap-article-body]');

    if (!body || body.dataset.enhanced === 'true') return;

    const nodes = Array.from(body.childNodes);

    if (!nodes.some(node =>
      node.nodeType === 1 &&
      (node.tagName === 'H2' || node.tagName === 'BLOCKQUOTE')
    )) return;

    const fragment = document.createDocumentFragment();

    let section = null;
    let index = 0;

    let preface = document.createElement('div');
    preface.className = 'zap-editorial__preface';

    function isImageNode(node) {
      if (node.nodeType !== 1) return false;

      if (node.tagName === 'IMG' || node.tagName === 'FIGURE') {
        return true;
      }

      if (
        node.matches('p,div') &&
        node.querySelector('img') &&
        !node.textContent.trim()
      ) {
        return true;
      }

      return false;
    }

    function imageAlt(node) {
      const img = node.tagName === 'IMG'
        ? node
        : node.querySelector('img');

      return img ? (img.getAttribute('alt') || '') : '';
    }

    function finishPreface() {
      if (
        preface.childNodes.length &&
        (
          preface.textContent.trim() ||
          preface.querySelector('img,video,iframe,blockquote')
        )
      ) {
        fragment.appendChild(preface);
      }

      preface = document.createElement('div');
      preface.className = 'zap-editorial__preface';
    }

    function finishSection() {
      if (!section) return;

      if (!section.media.childNodes.length) {
        section.root.classList.add(
          'zap-editorial__interview--text-only'
        );
      }

      fragment.appendChild(section.root);
      section = null;
    }

    function createSection(heading) {
      index++;

      const root = document.createElement('section');

      root.className =
        'zap-editorial__interview' +
        (index % 2 === 0
          ? ' zap-editorial__interview--reverse zap-editorial__interview--pink'
          : '');

      const copy = document.createElement('div');
      copy.className = 'zap-editorial__interview-copy';

      const media = document.createElement('div');
      media.className = 'zap-editorial__interview-media';

      // No repeated "THE INTERVIEW" label.
      copy.appendChild(heading);

      root.appendChild(media);
      root.appendChild(copy);

      section = { root, copy, media };
    }

    function createTestimonial(blockquote) {
      const wrapper = document.createElement('aside');

      wrapper.className = 'zap-editorial__testimonial';
      wrapper.setAttribute(
        'aria-label',
        'Customer testimonial'
      );

      const mark = document.createElement('span');
      mark.className = 'zap-editorial__testimonial-mark';
      mark.textContent = '“';
      mark.setAttribute('aria-hidden', 'true');

      const content = document.createElement('div');
      content.className = 'zap-editorial__testimonial-content';

      // Preserve original Shopify quotation markup,
      // including attribution and optional logo.
      content.appendChild(blockquote);

      wrapper.appendChild(mark);
      wrapper.appendChild(content);

      return wrapper;
    }

    nodes.forEach(function (node) {

      if (
        node.nodeType === 1 &&
        node.tagName === 'H2'
      ) {
        finishSection();
        finishPreface();
        createSection(node);
      }

      else if (
        node.nodeType === 1 &&
        node.tagName === 'BLOCKQUOTE'
      ) {
        finishSection();
        finishPreface();

        fragment.appendChild(
          createTestimonial(node)
        );
      }

      else if (section) {

        if (isImageNode(node)) {
          section.media.appendChild(node);

          const alt = imageAlt(node).toLowerCase();

          if (alt.includes('logo')) {
            section.media.classList.add(
              'zap-editorial__interview-media--logo'
            );
          }

        } else {
          section.copy.appendChild(node);
        }

      }

      else {
        preface.appendChild(node);
      }

    });

    finishSection();
    finishPreface();

    body.replaceChildren(fragment);
    body.dataset.enhanced = 'true';
  }

  function init() {
    document
      .querySelectorAll('[data-zap-editorial]')
      .forEach(buildArticle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();
